<script>
import BookmakerOddsButton from '../BookmakerOddsButton/BookmakerOddsButton.vue';
import BookmakerJoinButton from '../BookmakerOddsButton/BookmakerJoinButton.vue';
import { mapGetters } from 'vuex';
export default {
  name: 'GroupOneRaceSelection',
  components: {
    BookmakerOddsButton,
    BookmakerJoinButton,
  },
  props: {
    selection: {
      type: Object,
      default: () => {},
    },
    isMobile: {
      type: Boolean,
      default: () => false,
    },
    bookmaker: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters({
      eventData: 'GroupOneRaceTips/getEventOdds',
    }),
    selectionOddsValue() {
      const { selection, eventData } = this;
      const selectionOdds = eventData.filter(eventSelection => eventSelection.selectionId == selection.selectionId);
      return selectionOdds.length > 0 ? selectionOdds[0].price.value : '';
    },
    selectionCompetitorString() {
      const { selection } = this;
      return `${selection.competitorNumber}. ${selection.competitorName} (${selection.barrierNumber})`;
    },
  },
};
</script>

<template>
  <div class="group-one-race-selection">
    <div class="group-one-race-selection__container">
      <img :src="selection.silkImageUrl" class="group-one-race-selection__silk" >
      <div class="group-one-race-selection__competitor">{{ selectionCompetitorString }}</div>
      <div class="group-one-race-selection__buttons">
        <BookmakerOddsButton
          :bookmaker-id="bookmaker.bookmakerName"
          :bookmaker-link="bookmaker.primaryBookmakerUrl"
          :value="selectionOddsValue"
        />
        <template v-if="!isMobile">
          <BookmakerJoinButton
            :bookmaker-id="bookmaker.bookmakerName"
            :bookmaker-link="bookmaker.secondaryBookmakerUrl"
            :header-text="bookmaker.buttonHeader"
            :details-text="bookmaker.buttonDetails"
          />
        </template>
      </div>
    </div>
  </div>
</template>
